import { createSlice } from '@reduxjs/toolkit'
import { deleteCookie, setCookie } from 'cookies-next'
import { IRedux } from '../types'

const initialState: IRedux['auth'] = {
  user: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
  activeWindow: 'login',
  showMiniAppPublicOffer: false,
  miniAppCrmData: null,
}

export const { actions: authActions, reducer: authReducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false
      state.isError = false
      state.isSuccess = false
      state.message = ''
      state.showMiniAppPublicOffer = false
      state.miniAppCrmData = null
    },
    logout: () => {
      deleteCookie('user_id', { path: '/' })
      deleteCookie('access_token', { path: '/' })
      deleteCookie('refresh_token', { path: '/' })

      return initialState
    },
    setUser: (state, action) => {
      state.user = action.payload
      setCookie('user_id', action.payload?.id, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
      setCookie('access_token', action.payload?.access_token, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
      setCookie('refresh_token', action.payload?.refresh_token, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
    },
    setActiveWindow: (state, action) => {
      state.activeWindow = action.payload
    },
    updateUser: (state, action) => {
      if (state.user) {
        if (action.payload.name != null) {
          state.user.name = action.payload.name
        }
        if ('date_of_birth' in action.payload) {
          state.user.date_of_birth = action.payload.date_of_birth
        }
      }
    },
    setPhone: (state, action) => {
      if (state.user) {
        state.user.phone = action.payload
      }
    },
    updateTokens: (state, action) => {
      if (state.user) {
        state.user.access_token = action.payload.access_token
        state.user.refresh_token = action.payload.refresh_token

        setCookie('access_token', action.payload.access_token, {
          maxAge: 30 * 24 * 60 * 60,
          path: '/',
        })
        setCookie('refresh_token', action.payload.refresh_token, {
          maxAge: 30 * 24 * 60 * 60,
          path: '/',
        })
      }
    },
    setShowMiniAppPublicOffer: (state, action) => {
      state.showMiniAppPublicOffer = action.payload
      // Backward-compatible mirror until old selectors are removed.
    },
    setMiniAppCrmData: (state, action) => {
      state.miniAppCrmData = action.payload
    },
  },
})
